import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTickersAction } from "../actions";
import {
  instrumentSelector,
  selectedInstrumentSelector,
  setSelectedInstrument,
  loadedInstrumentSelector
} from "../store/slice/trade";

/**
 *
 * @returns {[{
 *  instruments: (import("../..").IInstrument)[],
 *  loading: boolean,
 *  error: object,
 * }, {
 *  getInstruments: () => void
 * }]}
 */
const useInstruments = () => {
  const instrumentsState = useSelector(instrumentSelector);
  const dispatch = useDispatch();

  const getInstruments = useCallback(instrumentIds => dispatch(getTickersAction(instrumentIds)), [dispatch]);

  return [instrumentsState, { getInstruments }];
};

/**
 *
 * @returns {[{
 *  selectedInstrument: Record<string, (import("../..").IInstrument)>,
 * }, {
 * onChangeSelectedInstrument: (id: (import("../..").IInstrument['instrumentId'])) => void
 * }]}}
 */
export const useInstrument = () => {
  const selectedInstrument = useSelector(selectedInstrumentSelector);
  const loadedInstruments = useSelector(loadedInstrumentSelector);
  let isIpo = true;
  for (let key in selectedInstrument) {
    if (selectedInstrument[key]?.startingDate) {
      isIpo = false;
      break
    }
  }
  const dispatch = useDispatch();
  const onChangeSelectedInstrument = useCallback(
    id => {
      // console.log('id', id);
      dispatch(setSelectedInstrument(id));
    },
    [dispatch]
  );

  
  return [{ selectedInstrument, isIpo, loadedInstruments }, { onChangeSelectedInstrument }];
};

export default useInstruments;
